import { Layers } from "lucide-react";
import React from "react";

import { IgAvatar, IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";

// Onsite-upsell modifications panel empty state: upsells aren't built by
// selecting page elements, so there's no navigate/select prompt — the panel
// keeps its "Active modifications" header and changes appear here as built.
export const ModificationsWillAppearEmptyState = () => {
  const theme = useTheme();

  return (
    <Stack sx={{ flex: 1, minHeight: 0 }}>
      <Stack sx={{ px: 4, py: 4 }}>
        <IgTypography variant="body1" fontWeight={600}>
          Active modifications
        </IgTypography>
      </Stack>
      <Stack
        alignItems="center"
        spacing={5}
        sx={{ px: 5, py: 16, textAlign: "center" }}
      >
        <IgAvatar
          variant="circular"
          sx={{
            backgroundColor: theme.igPrimitives.gray[600],
            width: 50,
            height: 50,
          }}
        >
          <Layers size={24} color={theme.palette.text.placeholder} />
        </IgAvatar>
        <Stack spacing={2} alignItems="center" maxWidth={292}>
          <IgTypography fontWeight={600}>
            Modifications will appear here
          </IgTypography>
          <IgTypography variant="body2" color={theme.palette.text.secondary}>
            Changes will show up here as they're built.
          </IgTypography>
        </Stack>
      </Stack>
    </Stack>
  );
};
